import React, { useState, useEffect, useCallback, useMemo, lazy, Suspense } from 'react';
import { Users, Cake, UserX } from 'lucide-react';
import Tabs from '../../ui/Tabs.jsx';

// Lazy load the modern table components
const ContactsModern = lazy(() => import('../../ModernTable/ContactsModern.jsx'));
const BirthdaysModern = lazy(() => import('../../ModernTable/BirthdaysModern.jsx'));
const DeactivatedContactsModern = lazy(() => import('../../ModernTable/DeactivatedContactsModern.jsx'));

const ContactsTabs = ({ onTabChange, headerActions }) => {
    const [contactsCounts, setContactsCounts] = useState({ contacts: 0, birthdays: 0, deactivated: 0 });

    const fetchContactsCounts = useCallback(async () => {
        try {
            const response = await fetch('index.php/contacts/getNumberOfContacts');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setContactsCounts({
                contacts: data.contacts,
                birthdays: data.birthdays,
                deactivated: data.deactivated,
            });
        } catch (error) {
            console.error('Error fetching lead counts:', error);
            // Hier könnten Sie eine Fehlerbehandlung hinzufügen, z.B. eine Benachrichtigung für den Benutzer
        }
    }, []);

    useEffect(() => {
        fetchContactsCounts();
    }, [fetchContactsCounts]);

    const tabsData = useMemo(() => [
        {
            id: 'contacts',
            name: 'Kontakte',
            icon: Users,
            count: contactsCounts.contacts,
            content: (
                <Suspense fallback={<div className="text-center py-3">Lädt...</div>}>
                    <ContactsModern key="contacts-modern" />
                </Suspense>
            )
        },
        {
            id: 'birthdays',
            name: 'Geburtstage',
            icon: Cake,
            count: contactsCounts.birthdays,
            content: (
                <Suspense fallback={<div className="text-center py-3">Lädt...</div>}>
                    <BirthdaysModern key="birthdays-modern" />
                </Suspense>
            )
        },
        {
            id: 'deactivated',
            name: 'Deaktivierte Kontakte',
            icon: UserX,
            count: contactsCounts.deactivated,
            content: (
                <Suspense fallback={<div className="text-center py-3">Lädt...</div>}>
                    <DeactivatedContactsModern key="deactivated-modern" />
                </Suspense>
            )
        },
    ], [contactsCounts]);

    return (
        <div>
            <Tabs tabs={tabsData} onTabChange={onTabChange} headerActions={headerActions} />
        </div>
    );
};

export default ContactsTabs;